import type { FC } from 'react';
import { Container } from './Loader.styles';
import LoaderImage from '@/assets/images/loader.gif';

interface Props {
  fullPage?: boolean;
  inline?: boolean;
  overlay?: boolean;
}

const Loader: FC<Props> = ({ fullPage, inline, overlay }: Props) => {
  const loaderImage = (
    <img className="loader" src={LoaderImage} alt="Loading..." />
  );

  if (inline) {
    return loaderImage;
  }

  return (
    <Container
      fullPage={fullPage}
      overlay={overlay}
      className="loader-container"
    >
      {loaderImage}
    </Container>
  );
};

export default Loader;
